// extracted by mini-css-extract-plugin
export default {"tech":"index_tech_Pmy6A"};